import * as React from 'react';
import { Button, Form, Icon, Notification } from '../';
import * as shortid from 'shortid';

interface Props {
  fields: any;
  handleChange?: Function;
  handleSubmit: Function;
  validate: Function;
  showSkipButton: boolean;
  type: string;
  buttonText: string;
  getDispatch: Function;
  disabled: boolean;
  values: any;
  resetOnSubmit?: boolean;
}

interface State {
  fieldIndex: number;
  finished: boolean;
  data: any;
  key: string;
}

class TypeForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      fieldIndex: 0,
      finished: false,
      data: {},
      key: shortid.generate(),
    };
    this.handleNext = this.handleNext.bind(this);
    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSkip = this.handleSkip.bind(this);
  }

  handleSkip() {
    this.setState({
      fieldIndex: this.props.fields.length - 1,
      finished: true,
    });
  }

  handleNext() {
    if (
      this.props.validate(
        this.state.data,
        (index) => this.state.fieldIndex === index,
      )
    ) {
      this.setState(
        {
          fieldIndex: Math.min(
            this.state.fieldIndex + 1,
            this.props.fields.length + 1,
          ),
          finished: false,
        },
        () => {
          if (this.state.fieldIndex >= this.props.fields.length) {
            this.setState({
              finished: true,
            });
          }
        },
      );
    }
  }

  handlePrevious() {
    this.setState({
      fieldIndex: Math.max(this.state.fieldIndex - 1, 0),
      finished: false,
    });
  }

  handleChange(data) {
    this.props.handleChange(data);
    this.setState({ data });
  }

  handleSubmit(data) {
    if (this.state.finished) {
      this.props.handleSubmit(data);
      if (this.props.resetOnSubmit) {
        this.setState({
          fieldIndex: 0,
          finished: false,
          data: {},
          key: shortid.generate(),
        });
      }
      return;
    }
    this.handleNext();
  }

  render() {
    return (
      <div className={`typeform ${this.state.finished ? 'is-complete' : ''}`}>
        <div>
          {this.state.finished && (
            <div className="typeform__confirmation">
              <Notification type="default">
                Last step - please double check all fields.
              </Notification>
            </div>
          )}
          <Form
            key={this.state.key}
            selectedIndex={this.state.fieldIndex}
            {...this.props}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          {!this.state.finished && (
            <div className="levels">
              <div className="level">
                <div className="level-left">
                  {this.state.fieldIndex > 0 && (
                    <Button
                      key={this.state.fieldIndex - 1}
                      className="typeform__button typeform__button-prev is-default"
                      handleClick={this.handlePrevious}
                    >
                      <Icon icon="undo" />
                      &nbsp; Back
                    </Button>
                  )}
                </div>
                <div className="level-right">
                  <Button
                    key={this.state.fieldIndex + 1}
                    className="typeform__button typeform__button-next is-primary"
                    handleClick={this.handleNext}
                  >
                    Next &nbsp;
                    <Icon icon="angle-right" />
                  </Button>
                </div>
              </div>
              {this.props.showSkipButton && (
                <div className="level-right">
                  <a
                    key={this.state.fieldIndex + 3}
                    onClick={this.handleSkip}
                    className="typeform__button typeform__button-skip"
                  >
                    Skip &nbsp;
                    <Icon icon="angle-double-right" />
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default TypeForm;
